/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Questions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Question from './Question/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Questions({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Questions.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-g0REU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-g0REU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-g0REU': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-g0REU': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Question
  viewPath={`${viewPath}/Question`}
/>
</div>
{children}
</React.Fragment>)
}